export default __webpack_public_path__ + "static/about-2-2d14b8789f67bc94a5f8e622ade5d092.jpg";